module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_1@2x.589dcb42.png";